/* tslint:disable */
import FontAwesome5_Pro_BrandsFont from 'assets/fonts/FontAwesome5_Pro_Brands.ttf';
import FontAwesome5_Pro_LightFont from 'assets/fonts/FontAwesome5_Pro_Light.ttf';
import FontAwesome5_Pro_RegularFont from 'assets/fonts/FontAwesome5_Pro_Regular.ttf';
import FontAwesome5_Pro_SolidFont from 'assets/fonts/FontAwesome5_Pro_Solid.ttf';
import MontserratFont from 'assets/fonts/Montserrat-Bold.ttf';
import MontserratFontExtraBold from 'assets/fonts/Montserrat-ExtraBold.ttf';
import MontserratFontMedium from 'assets/fonts/Montserrat-Medium.ttf';
import MontserratFontRegular from 'assets/fonts/Montserrat-Regular.ttf';
import MontserratFontSemiBold from 'assets/fonts/Montserrat-SemiBold.ttf';
import OpenSansBoldFont from 'assets/fonts/OpenSans-Bold.ttf';
import OpenSansBoldItalicFont from 'assets/fonts/OpenSans-BoldItalic.ttf';
import OpenSansExtraBoldFont from 'assets/fonts/OpenSans-ExtraBold.ttf';
import OpenSansItalicFont from 'assets/fonts/OpenSans-Italic.ttf';
import OpenSansRegularFont from 'assets/fonts/OpenSans-Regular.ttf';
import OpenSansSemiBoldFont from 'assets/fonts/OpenSans-SemiBold.ttf';
import SourceCodeProBoldFont from 'assets/fonts/SourceCodePro-Bold.ttf';
import $ from 'jquery';
import React from 'react';
import {AppRegistry, Platform} from 'react-native';
import FontAwesome5BrandsFont from 'react-native-vector-icons/Fonts/FontAwesome5_Brands.ttf';
import FontAwesome5RegularFont from 'react-native-vector-icons/Fonts/FontAwesome5_Regular.ttf';
import FontAwesome5SolidFont from 'react-native-vector-icons/Fonts/FontAwesome5_Solid.ttf';
import FontAwesomeFont from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
// Use prebuilt version of RNVI in dist folder
// Generate required css
import iconFont from 'react-native-vector-icons/Fonts/Ionicons.ttf';
import MaterialCommunityIconsFont from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';

import LegacyMyRewardsApp from 'components/LegacyMyRewardsApp';

import RootApp from './App';

if (!window.isLegacyMyRewards || !window.jQuery) {
  window.jQuery = $;
}

if (!window.isLegacyMyRewards || !window.$) {
  window.$ = $;
}

const fontStyles = `
  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
  }
  @font-face {
    src: url(${iconFont});
    font-family: Ionicons;
  }
  @font-face {
    src: url(${MaterialCommunityIconsFont});
    font-family: MaterialCommunityIcons;
  }
  @font-face {
    src: url(${FontAwesomeFont});
    font-family: FontAwesome;
  }
  @font-face {
    src: url(${FontAwesome5BrandsFont});
    font-family: FontAwesome5_Brands;
  }
  @font-face {
    src: url(${FontAwesome5RegularFont});
    font-family: FontAwesome5_Regular;
  }
  @font-face {
    src: url(${FontAwesome5SolidFont});
    font-family: FontAwesome5_Solid;
  }
  @font-face {
    src: url(${FontAwesome5_Pro_LightFont});
    font-family: FontAwesome5_Pro_Light;
  }
  @font-face {
    src: url(${FontAwesome5_Pro_SolidFont});
    font-family: FontAwesome5_Pro_Solid;
  }
  @font-face {
    src: url(${FontAwesome5_Pro_RegularFont});
    font-family: FontAwesome5_Pro_Regular;
  }
  @font-face {
    src: url(${FontAwesome5_Pro_BrandsFont});
    font-family: FontAwesome5_Pro_Brands;
  }
  @font-face {
    src: url(${MontserratFont});
    font-family: Montserrat-Bold;
    font-weight: 700;
  }
  @font-face {
    src: url(${MontserratFontExtraBold});
    font-family: Montserrat-ExtraBold;
    font-weight: 800;
  }
  @font-face {
    src: url(${MontserratFontRegular});
    font-family: Montserrat-Regular;
    font-weight: 400;
  }
  @font-face {
    src: url(${MontserratFontMedium});
    font-family: Montserrat-Medium;
    font-weight: 500;
  }
  @font-face {
    src: url(${MontserratFontSemiBold});
    font-family: Montserrat-SemiBold;
    font-weight: 700;
  }
  @font-face {
    src: url(${OpenSansBoldFont});
    font-family: OpenSans-Bold;
    font-weight: 700;
  }
  @font-face {
    src: url(${OpenSansBoldItalicFont});
    font-family: OpenSans-BoldItalic;
    font-weight: 700;
  }
  @font-face {
    src: url(${OpenSansItalicFont});
    font-family: OpenSans-Italic;
  }
  @font-face {
    src: url(${OpenSansSemiBoldFont});
    font-family: OpenSans-SemiBold;
    font-weight: 600;
  }
  @font-face {
    src: url(${OpenSansRegularFont});
    font-family: OpenSans-Regular;
  }
  @font-face {
    src: url(${OpenSansExtraBoldFont});
    font-family: OpenSans-ExtraBold;
    font-weight: 800;
  }
  @font-face {
    src: url(${SourceCodeProBoldFont});
    font-family: SourceCodePro-Bold;
    font-weight: 700;
  }
`;

// Create stylesheet
const style = document.createElement('style');
style.appendChild(document.createTextNode(fontStyles));

// Inject stylesheet
document.head.appendChild(style);

const appName = 'CaesarsRewards';

const App = () => {
  return <RootApp />;
};

const initializeLegacyTest = () => {
  window.isLegacyMyRewards = true;
  const root = document.getElementById('root');

  if (root) {
    const myrewardsHeaderComponent = document.createElement('div');
    myrewardsHeaderComponent.id = 'myrewardsHeaderComponent';
    root.insertAdjacentElement('beforebegin', myrewardsHeaderComponent);

    const enterpriseFooterComponent = document.createElement('div');
    enterpriseFooterComponent.id = 'enterpriseFooterComponent';
    root.insertAdjacentElement('afterend', enterpriseFooterComponent);

    const acceptTermsComponent = document.createElement('div');
    acceptTermsComponent.id = 'acceptTermsComponent';
    root.insertAdjacentElement('beforebegin', acceptTermsComponent);

    const myrewardsFooterComponent = document.createElement('div');
    myrewardsFooterComponent.id = 'myrewardsFooterComponent';
    root.insertAdjacentElement('afterend', myrewardsFooterComponent);
  }
};

try {
  if (process.env.REACT_APP_LEGACY_TEST === 'true') {
    initializeLegacyTest();
  }
} catch (e) {}

if (window.isLegacyMyRewards) {
  AppRegistry.registerComponent(appName, () => LegacyMyRewardsApp);
  AppRegistry.runApplication(appName, {
    rootTag: document.getElementById('root'),
  });
} else {
  AppRegistry.registerComponent(appName, () => App);
  AppRegistry.runApplication(appName, {
    rootTag: document.getElementById('root'),
  });
}

export default App;
